export default "__VITE_PUBLIC_ASSET__baeeb8bb__"